import isElectron from 'is-electron';
import { v4 as uuidv4 } from 'uuid';

/**
 * Stable identifier for this client session, sent on every request as
 * `x-client-session-id` and attached to telemetry.
 *
 * fr-client in electron satisfies `isElectron()` but has no `window.args`, so fall
 * back to a generated uuid rather than assuming the launch argument is present.
 */
export const clientSessionId = isElectron()
    ? window.args?.['--client-session-id'] ?? uuidv4()
    : uuidv4();
